<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <shift-period-edit-form
        @on-submit="onShiftPeriodEditSubmit"
      ></shift-period-edit-form>
    </div>
  </div>
</template>
<script>
import ShiftPeriodEditForm from "./ShiftPeriodEditForm.vue";

export default {
  components: {
    ShiftPeriodEditForm: ShiftPeriodEditForm
  },
  data() {
    return {
      shiftPeriodEditModel: {}
    };
  },
  methods: {
    onShiftPeriodEditSubmit(model) {
      this.shiftPeriodEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'shifts/' + this.shiftPeriodEditModel.id, Object.assign(this.shiftPeriodEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
